<template>
  <v-col :cols="btnParc ? 12 : 3" :class="btnParc ? 'pt-0' : '' ">
    <template v-if="btnParc">
      <input-text v-show="false" label="Parcelas" v-model="model" required />
      <v-label>Parcelas:</v-label>
      <v-item-group required v-model="model" @change="change">
        <v-row class="justify-center">
          <v-col :cols="parseInt(12/parcelas.length)" v-for="(item, i) in parcelas" :key="i">
            <v-item v-slot="{ active, toggle }" :value="item.value">
              <v-btn block large tile @click="toggle" :color="active? 'grey darken-3' : ''" class="px-4 text-lowercase" :dark="active">
                {{item.text}}
              </v-btn>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
    </template>
    <input-select v-else :options="parcelas" required name="Parcelas" label="Parcelar em até:" v-model="model" @change="change"></input-select>
  </v-col>
</template>

<script>
export default {
  props: {
    value: null,
    anoFab: null
  },
  data () {
    return {
      parcelas: []
    }
  },
  watch: {
    anoFab (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.carregarParcelas();
      }
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    btnParc: function () {
      return this.parcelas.length < 6
    }
  },
  methods: {
    change (value) {
      this.$emit('change', value)
    },
    carregarParcelas () {
      const th = this
      th.$api.Multiplo.ListProdutoRedeParcela({}).then(function (response) {
        if (th.anoFab) {
          const tabela = th.$param.TabelaTaxas.find(item => {
            return th.anoFab >= item.anoInicio && th.anoFab <= item.anoFim
          })
          if (tabela && tabela.parcelas) {
            th.parcelas = tabela.parcelas.map(p => ({ value: p, text: p + 'x' }))
          } else {
            th.parcelas = response.map(item => ({ value: item, text: item + 'x' }))
          }
        } else {
          th.parcelas = response.map(item => ({ value: item, text: item + 'x' }))
        }
        th.setParcela(true)
        th.$emit('load', th.parcelas.length < 6)
      })
    },
    setParcela (loading) {
      const ultima = this.parcelas && this.parcelas.length > 0 ? this.parcelas[this.parcelas.length - 1].value : null
      if (!loading && this.model.Parcelas > ultima) { this.$set(this.model, 'Parcelas', ultima) }
    },
  },
  beforeMount () {
    this.carregarParcelas()
  }
}
</script>
